import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {Routes, RouterModule} from '@angular/router';
import {HomeComponent} from './home/home.component';
import {ThemeparkComponent} from './themepark/themepark.component';
import {PacksComponent} from './packs/packs.component';

const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'park', component: ThemeparkComponent},
  {path: 'packs', component: PacksComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {scrollPositionRestoration: 'enabled'})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
